import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import userContext from '../../../../context/users/UserContext';
import { ACTIONS, USERTYPES } from '../../../../constants/Constants';
import SubModalityPreferences from './SubModalityPreferences';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';
import { TooltipHost, Checkbox, ComboBox } from '@fluentui/react';
import { t, use } from "i18next";
import { choiceGroupStyles } from '../../helpers/Styles';
import ClearIcon from '../../../../components/SVGComponents/ClearIcon';

const SupervisorAssignmentPreferences = (props) => {
    const [searchParams] = useSearchParams();
    const { roles, authenticated, loadByUsername, userId } = useContext(userContext);

    const [selectedModality, setSelectedModality] = useState([]);
    const [checkAllModality, setCheckAllModality] = useState(false);

    useEffect(() => {
            if (!authenticated) {
        loadByUsername();
      }
    }, []);
    
    let modalityList = [];
    props.modalityList.map((modality) => {
      modalityList.push({
        key: modality.id,
        text: modality.name,
      });
    });

    const selectedModalityfunc = () =>{
      setSelectedModality(props.selectedModalityWithSubModality.map((m)=>m.modalityId));
    }

    const handleAllModalityCheckboxClick = () => {
      if (checkAllModality) {
          props.setSelectedModalityWithSubModality([]);
          setCheckAllModality(false);
      } else {
          const allSelectedModalityWithSubModality = props.modalityWithSubModalityList.map(modality => ({
              modalityId: modality.id,
              subModalities: []
          }));
  
          props.setSelectedModalityWithSubModality(allSelectedModalityWithSubModality);
          setCheckAllModality(true);
      }
    };
  
    useEffect(()=>{
      selectedModalityfunc();
      console.log("Selected Modality with sub modality : ", props.selectedModalityWithSubModality);
      const allModalitiesSelected = props.modalityWithSubModalityList.every(modality => {
        return props.selectedModalityWithSubModality.some(selectedModality => selectedModality.modalityId === modality.id);
      });
      setCheckAllModality(allModalitiesSelected);
    },[props.selectedModalityWithSubModality]);

    const handleModalityCheckBoxClick = ( e, isChecked, modalityId) =>{
      if(isChecked){
          let list1 = [...props.selectedModalityWithSubModality, {modalityId:modalityId, subModalities:[]}];
          props.setSelectedModalityWithSubModality(list1);
          setSelectedModality((prev)=>{
            prev.push(modalityId);
            return prev;
          });
      }else{
          let list1 = props.selectedModalityWithSubModality.filter((m)=>m.modalityId != modalityId);
          props.setSelectedModalityWithSubModality(list1);
          setSelectedModality(list1.map((m)=>m.modalityId));
      }
  }
  
    return (
      <>
      <div className="tab-section">
      {((roles[0] === USERTYPES.FIRMADMIN) || (roles[0] === USERTYPES.ADMIN)) && <>
        {props.modalityList?.length > 0 && (props.state.action == ACTIONS.ADD || props.state.action == ACTIONS.EDIT)
          && ( <>
            <div className="ms-Grid" dir="ltr">
              <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                <p style={{ fontSize: "20px", fontWeight: "600", padding: "0px 0px",}}>
                  {t("user.modality-preferences")}
                </p>
              </section>
                    
                <div className="ms-Grid-row">
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl9">
                    <p className="form-field-key" style={{ marginBottom: "20px", fontWeight: "bold" }}>
                    {t("user.select-auto-assignment-modality-preference")}
                    </p>
                  </div>
                </div>

                <div className="ms-Grid-row">
                  <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                    <Checkbox
                      label="Select All"
                      onChange={handleAllModalityCheckboxClick}
                      id="all"
                      checked={checkAllModality==true}
                    />
                  </div>
                </div>

                <div className="ms-Grid-row">
                  {props.modalityWithSubModalityList.map((modality,index) => {
                    return (
                        <div key={index} className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4" style={{display:"flex"}}>
                          <div className="ms-sm8 ms-md4 ms-lg3 ms-xl3" style={{ display: "block",whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis"}}>
                            <Checkbox
                              key={modality.id}
                              label={modality.name}
                              name={modality.name}
                              onChange={(e, isChecked) => handleModalityCheckBoxClick(e,isChecked,modality.id)}
                              checked={selectedModality.includes(modality.id)}
                            />
                          </div>
                          </div>
                    );
                  })}
                </div>
            </div>
        </>  )}
        {props.state.action == ACTIONS.VIEW && (
          <>
            <div className="ms-Grid" dir="ltr">
              <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                <p style={{ fontSize: "20px", fontWeight: "600", padding: "0px 0px",}}>
                  {t("user.modality-preferences")}
                </p>
              </section>

                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <table className="borderless-table" style={{borderCollapse:"collapse", width:"100%"}}>
                        <thead>
                          <tr key="heading">
                            <th className="form-heading" style={{border:"none",padding:"8px",textAlign:"left",width:"30%"}}>Auto Assignment Modality Preference</th>
                          </tr>
                        </thead>
                        <tbody>
                        {props.selectedModalitySubmodalityNames.map((modality, index)=>{
                          return(
                            <>
                              <tr>
                                <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td>
                              </tr>
                            </> 
                          )
                        })}
                      </tbody>
                  </table>
                </div>
            </div>
          </>
        )
        }
        </>}
        </div>
      </>
    );
  }

export default SupervisorAssignmentPreferences